<div class="row">
    <div class="col-12 mt-4 mt-lg-0 pl-0 top-bar banner">
      <button *ngIf="isPinned && !config.pinButtonHidden" class="btn btn-tertiary btn-pin" (click)="config.pinCallBackFunction()" title="Unpin {{config.page}}">
        <i class="fas fa-thumbtack"></i>
      </button>
      <button *ngIf="!isPinned && !config.pinButtonHidden" class="btn btn-tertiary btn-pin" (click)="config.pinCallBackFunction()" title="Pin {{config.page}}">
        <i class="far fa-thumbtack"></i>
      </button>
      <h1>{{config.title}}</h1>
    </div>
  </div>